<template>
    <div class="panel">
        <div class="panel-head">
            <div>
                <div class="panel-title">Top Agents Per Booking</div>
            </div>
        </div>

        <div v-if="!agents.length" class="empty-state">No sales data yet</div>

        <div class="agent-row" v-for="(agent, index) in agents" :key="agent.name">
            <div class="agent-rank" :class="{ first: index === 0 }">{{ index + 1 }}</div>
            <div class="agent-name">{{ agent.name }}</div>
            <div class="agent-sales">{{ agent.sales }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        agents: { type: Array, default: () => [] }
    }
}
</script>

<style lang="scss" scoped>
.panel {
    background: var(--surface);
    border: 1px solid var(--line);
    border-radius: var(--radius);
    box-shadow: var(--shadow);
    padding: 1.25rem 1.4rem;
    height: 100%;
}

.panel-title {
    font-size: .95rem;
    font-weight: 700;
}

.panel-head {
    margin-bottom: .25rem;
}

.empty-state {
    font-size: .78rem;
    color: var(--ink-faint);
    padding: .75rem 0;
}

.agent-row {
    display: flex;
    align-items: center;
    gap: .7rem;
    padding: .55rem 0;
    border-bottom: 1px solid var(--line);

    &:last-child {
        border-bottom: none;
    }
}

.agent-rank {
    width: 22px;
    height: 22px;
    border-radius: 6px;
    background: var(--paper);
    color: var(--ink-soft);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'IBM Plex Mono', monospace;
    font-size: .7rem;
    font-weight: 600;

    &.first {
        background: var(--amber-soft);
        color: #a4700f;
    }
}

.agent-name {
    flex: 1;
    font-size: .82rem;
    font-weight: 600;
}

.agent-sales {
    font-family: 'IBM Plex Mono', monospace;
    font-size: .8rem;
    font-weight: 600;
}
</style>


// WEBPACK FOOTER //
// topAgents.vue?083dc28c